import CardTitle from "./CardTitle";

const Empowerment = () => {
   return [
      <div>
         <CardTitle num={1} />
         <ul>
            <li>
               Budget decisions are made by budget holders in collaboration with
               key stakeholders; creative / technical decisions are made by
               creators / technicians, in collaboration with budget holders
            </li>
            <li>People leaders don’t second-guess or micro-manage</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={2} />
         <ul>
            <li>Appropriate attendance, always</li>
            <li>Meetings can be a place to learn</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={3} />
         <ul>
            <li>There’s no class structure</li>
            <li>
               We always hire people smarter than ourselves in their area of
               expertise
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={4} />
         <ul>
            <li>The Avado community takes precedence over free-agents</li>
            <li>Responsible, accountable freedom over control</li>
         </ul>
      </div>,

      <div>
         <CardTitle num={5} />
         <h3>We smile at: 😍</h3>
         <ul>
            <li>Consultation and collaboration with others</li>
         </ul>
         <br />
         <h3>We frown at: 😒</h3>
         <ul>
            <li>‘Hierarchialism’</li>
            <li>‘Bureaucraticism’</li>
            <li>‘Corporate’ culture</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={6} />
         <ul>
            <li>
               People leaving Avado take a little of Avado with them, and leave
               a little of themselves behind
            </li>
         </ul>
      </div>,
      <div>
         <CardTitle num={7} />
         <ul>
            <li>Viewpoints are additive, not competitive</li>
         </ul>
      </div>,
      <div>
         <CardTitle num={8} />
         <ul>
            <li>Questions bring greatness</li>
            <li>Anyone is free to talk to anyone else</li>
         </ul>
      </div>,
   ];
};

export default Empowerment;
